import jsPDF from 'jspdf';
import dayjs from 'dayjs';
import { formatTextListAnswer } from '../Admin/FormBuilder/utils/textListItems';
import { formatConsentAnswer } from '../Admin/FormBuilder/utils/consentItems';

// Same non-input/upload type lists FormFillPage.jsx and the backend controller
// already use — file/signature answers hold no meaningful static value here.
const NON_INPUT_TYPES = ['richtext', 'image', 'button'];
const UPLOAD_TYPES = ['file', 'signature'];

// Builds the rows a "Form Submission" PDF should show: Submission Date first,
// then every answered, non-upload, non-structural field with a real value.
export const buildSubmissionPdfRows = (answers) => {
    const rows = [['Submission Date', dayjs().format('MMM D, YYYY h:mm A')]];

    answers.forEach((answer) => {
        if (NON_INPUT_TYPES.includes(answer.type) || UPLOAD_TYPES.includes(answer.type)) return;

        // text-list's value is an array of {label, value} objects, and
        // consent's is an array of booleans — a plain join would stringify
        // each text-list item as "[object Object]" and each consent entry
        // as "1"/"".
        let value;
        if (answer.type === 'text-list') {
            value = formatTextListAnswer(answer.value);
        } else if (answer.type === 'consent') {
            value = formatConsentAnswer(answer.value);
        } else if (answer.type === 'date' && dayjs(answer.value).isValid()) {
            // A bare "2003-04-13" is easy to misread as day-first — spell the
            // month out so the format can't be mistaken for anything else.
            value = dayjs(answer.value).format('MMM D, YYYY');
        } else {
            value = Array.isArray(answer.value) ? answer.value.join(', ') : answer.value;
        }
        if (value === null || value === undefined || value === '') return;

        rows.push([answer.label, String(value)]);
    });

    return rows;
};

// Renders the same label/value table as the submission emails into a single-page
// PDF, matching the reference "Form Submission" document design. Returns a Blob
// ready to attach to the multipart submission upload.
const generateSubmissionPdf = (formName, answers) => {
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();

    pdf.setFillColor(253, 242, 240);
    pdf.rect(0, 0, pageWidth, 20, 'F');

    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(12);
    pdf.setTextColor(20, 20, 20);
    pdf.text('Form Submission', 15, 13);

    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(9);
    pdf.text(dayjs().format('MMM D, YYYY, h:mm A'), pageWidth - 15, 13, { align: 'right' });

    let y = 35;
    const rows = buildSubmissionPdfRows(answers);

    pdf.setFontSize(10);
    rows.forEach(([label, value]) => {
        pdf.setTextColor(71, 84, 103);
        pdf.text(label, 15, y);
        pdf.setTextColor(16, 24, 40);
        pdf.text(value, 90, y, { maxWidth: pageWidth - 105 });
        y += 12;
    });

    return pdf.output('blob');
};

export default generateSubmissionPdf;
